import { Image, Linking, TouchableOpacity } from 'react-native';
import { Text, View } from '../Themed';

const InstagramIconPng = require('../../../assets/images/icon_instagram.png');
const LinkedinIconPng = require('../../../assets/images/icon_linkedin.png');
const YoutubeIconPng = require('../../../assets/images/icon_youtube.png');

export function SocialLinks(): JSX.Element {
  return (
    <tr>
      <td>
        <TouchableOpacity
          onPress={() => {
            Linking.openURL('https://www.instagram.com/snapcalorie/');
          }}
        >
          <Image
            source={InstagramIconPng}
            style={{
              margin: 10,
              height: 32,
              width: 32,
            }}
          />
        </TouchableOpacity>
      </td>
      <td>
        <TouchableOpacity
          onPress={() => {
            Linking.openURL('https://www.linkedin.com/company/snapcalorie/');
          }}
        >
          <Image
            source={LinkedinIconPng}
            style={{
              margin: 10,
              height: 32,
              width: 32,
            }}
          />
        </TouchableOpacity>
      </td>
      <td>
        <TouchableOpacity
          onPress={() => {
            Linking.openURL('https://www.youtube.com/@snapcalorie/shorts');
          }}
        >
          <Image
            source={YoutubeIconPng}
            style={{
              margin: 10,
              height: 32,
              width: 32,
            }}
          />
        </TouchableOpacity>
      </td>
    </tr>
  );
}

export default function SocialLinksFooter() {
  return (
    <View style={{ alignSelf: 'center', marginTop: 20 }}>
      <SocialLinks />
      <Text style={{ marginTop: 20 }}>
        Learn more at our <a href="https://www.snapcalorie.com/blog">Blog</a>
      </Text>
    </View>
  );
}
SocialLinksFooter.defaultProps = {
  style: {},
};
